export default {
    Periwinkle: {
        taxonomies: {
            order: 'rgb(180, 167, 197)',
            family: 'rgb(194, 196, 216)',
            genus: 'rgb(217, 230, 234)',
            species: 'mintcream',
            innermost: 'white'
        },
        previewImageBorders: 'white',
        logSightingsBackground: 'rgb(217, 230, 234, 0.3)',
        filters: {
            inactive: 'rgb(240, 231, 245)',
            active: 'rgb(140, 222, 199)',
            x: 'rgba(255, 255, 255, 0.8)',
            applyButton: 'rgb(41, 167, 167)',
            inner: 'white',
            border: 'gray'
        },
        background: 'white',
        text: 'black',
        link: 'rgb(98, 76, 115)'
    },

    Wood: {
        taxonomies: {
            order: 'rgb(177 147 133)',
            family: 'rgb(191, 175, 163)',
            genus: 'rgb(227 224 223)',
            species: 'rgb(240 243 247)',
            innermost: 'white'
        },
        previewImageBorders: 'white',
        logSightingsBackground: 'rgb(217, 230, 234, 0.3)',
        filters: {
            inactive: 'rgb(219 215 207)',
            active: 'rgb(147 212 235)',
            x: 'rgba(255, 255, 255, 0.8)',
            applyButton: 'rgb(74 158 208)',
            inner: 'white',
            border: 'gray'
        },
        background: 'white',
        text: 'black',
        link: 'rgb(98, 76, 115)'
    },

    Apple: {
        taxonomies: {
            order: 'rgb(158 186 162)',
            family: 'rgb(205 220 199)',
            genus: 'rgb(230 234 222)',
            species: 'rgb(243 249 246)',
            innermost: 'white'
        },
        previewImageBorders: 'white',
        logSightingsBackground: 'rgb(217, 230, 234, 0.3)',
        filters: {
            inactive: 'rgb(219 215 207)',
            active: 'rgb(147 212 235)',
            x: 'rgba(255, 255, 255, 0.8)',
            applyButton: 'rgb(74 158 208)',
            inner: 'white',
            border: 'gray'
        },
        background: 'white',
        text: 'black',
        link: 'rgb(98, 76, 115)'
    },

    Slate: {
        taxonomies: {
            order: 'rgb(162 194 209)',
            family: 'rgb(178 215 227)',
            genus: 'rgb(209 235 242)',
            species: 'rgb(235 244 245)',
            innermost: 'white'
        },
        previewImageBorders: 'white',
        logSightingsBackground: 'rgb(217, 230, 234, 0.3)',
        filters: {
            inactive: 'rgb(219 240 241)',
            active: 'rgb(147 212 235)',
            x: 'rgba(255, 255, 255, 0.8)',
            applyButton: 'rgb(74 158 208)',
            inner: 'white',
            border: 'gray'
        },
        background: 'white',
        text: 'black',
        link: 'rgb(98, 76, 115)'
    },

    // Dark: {
    //     inverted: true,
    //     darkAdjust: {
    //         filter: 'brightness(.85) contrast(1.1)'
    //     },
    //     dark: true,
    //     taxonomies: {
    //         order: 'rgb(43 45 67)',// old, darker and slightly more saturated purple 42 37 62
    //         family: 'rgb(25 32 53)',
    //         genus: 'rgb(24 28 40)',
    //         species: 'rgb(26 24 30)',
    //         innermost: 'rgb(36 33 43)'
    //     },
    //     previewImageBorders: 'rgb(18 18 18)',
    //     logSightingsBackground: 'rgb(92 89 145 / 10%',
    //     filters: {
    //         inactive: 'rgb(24 29 47)',//            24 29 47  OR 27 47 46
    //         active: 'rgb(16 30 70)',//              70 49 73  OR 40 72 71
    //         x: 'rgba(255, 255, 255, 0.24)',
    //         applyButton: 'rgb(76 47 80)',//         28 82 82  OR 16 30 70
    //         inner: 'rgb(18 18 18)',
    //         border: 'gray'
    //     },
    //     background: 'rgb(18 18 18)',
    //     text: 'rgb(255 255 255 / .87)',
    //     textMedium: 'rgb(255 255 255 / .6)', // .38 opacity for disabled
    //     link: 'rgb(189, 106, 196)'
    // },


    // DarkAltered: {
    //     inverted: true,
    //     dark: true,
    //     darkAdjust: {
    //         filter: 'brightness(.85) contrast(1.1)'
    //     },
    //     taxonomies: {
    //         order: 'rgb(42 37 62)',//   OR 40 46 57, the cheap screen version -- blue gray
    //         family: 'rgb(25 32 53)',
    //         genus: 'rgb(24 28 40)',
    //         species: 'rgb(26 24 30)',
    //         innermost: 'rgb(36 33 43)'
    //     },
    //     previewImageBorders: 'rgb(18 18 18)',
    //     logSightingsBackground: 'rgb(92 89 145 / 8%',
    //     filters: {
    //         inactive: 'rgb(24 29 47)',//            24 29 47  OR 27 47 46
    //         active: 'rgb(16 30 70)',//              70 49 73  OR 40 72 71
    //         x: 'rgba(255, 255, 255, 0.24)',
    //         applyButton: 'rgb(76 47 80)',//         28 82 82  OR 16 30 70
    //         inner: 'rgb(18 18 18)',
    //         border: 'gray'
    //     },
    //     background: 'rgb(18 18 18)',
    //     text: 'rgb(255 255 255 / .87)',
    //     textMedium: 'rgb(255 255 255 / .6)',
    //     link: 'rgb(189, 106, 196)'
    // },


    // DarkFixed: {
    //     inverted: false,
    //     dark: true,
    //     darkAdjust: {
    //         filter: 'brightness(.85) contrast(1.1)'
    //     },
    //     taxonomies: {
    //         order: 'rgb(26 24 30)',
    //         family: 'rgb(24 28 40)',
    //         genus: 'rgb(25 32 53)',
    //         species: 'rgb(40 46 57)',
    //         innermost: 'rgb(47 54 69)'
    //     },
    //     previewImageBorders: 'rgb(18 18 18)',
    //     logSightingsBackground: 'rgb(217 230 234 / 7%)',
    //     filters: {
    //         inactive: 'rgb(24 29 47)',//            24 29 47  OR 27 47 46
    //         active: 'rgb(16 30 70)',//              70 49 73  OR 40 72 71
    //         x: 'rgba(255, 255, 255, 0.24)',
    //         applyButton: 'rgb(76 47 80)',//         28 82 82  OR 16 30 70
    //         inner: 'rgb(18 18 18)',
    //         border: 'gray'
    //     },
    //     background: 'rgb(18 18 18)',
    //     text: 'rgb(255 255 255 / .87)',
    //     textMedium: 'rgb(255 255 255 / .6)',
    //     link: 'rgb(172 162 241)'
    // },


    DarkFixed2: {
        inverted: false,
        darkAdjust: {
            filter: 'brightness(.85) contrast(1.1)'
        },
        dark: true,
        taxonomies: {
            order: 'rgb(29 27 34)',
            family: 'rgb(28 34 49)',
            genus: 'rgb(31 38 62)',
            species: 'rgb(43 45 67)',
            innermost: 'rgb(50 53 79)'
        },
        previewImageBorders: 'rgb(18 18 18)',
        logSightingsBackground: 'rgb(217 230 234 / 7%)',
        filters: {
            inactive: 'rgb(24 29 47)',//            24 29 47  OR 27 47 46
            active: 'rgb(16 30 70)',//              70 49 73  OR 40 72 71
            x: 'rgba(255, 255, 255, 0.24)',
            applyButton: 'rgb(76 47 80)',//         28 82 82  OR 16 30 70
            inner: 'rgb(18 18 18)',
            border: 'gray'
        },
        background: 'rgb(18 18 18)',
        text: 'rgb(255 255 255 / .87)',
        textMedium: 'rgb(255 255 255 / .6)',
        link: 'rgb(172 162 241)'
    }
}